<button (click)="scroll()" #scrollToTop><span></span></button>